import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { apiClient } from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { PoweredByInvictaX } from "@/components/PoweredByInvictaX";

export function Register() {
  const [email, setEmailState] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [registrationOpen, setRegistrationOpen] = useState(true);

  useEffect(() => {
    apiClient.get("/auth/registration-status").then((r) => {
      setRegistrationOpen(!!r.data?.enabled);
    }).catch(() => setRegistrationOpen(false));
  }, []);

  const navigate = useNavigate();
  const { setEmail } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== password2) {
      setError("Passwörter stimmen nicht überein.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await apiClient.post("/auth/register", { email, password });
      localStorage.removeItem("authToken");
      localStorage.setItem("authEmail", email);
      setEmail(email);
      navigate("/");
    } catch (e) {
      console.error(e);
      setError(e.response?.data?.detail || "Registrierung fehlgeschlagen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="register-page">
      {!registrationOpen ? (
        <Card className="w-full max-w-md p-6 border border-slate-200 shadow-sm bg-white text-center" data-testid="register-disabled-card">
          <h1 className="text-lg font-semibold text-slate-900">Registrierung aktuell nur per Einladung</h1>
          <p className="mt-2 text-sm text-slate-600">
            Die öffentliche Registrierung ist derzeit deaktiviert. Bitte wende dich an deinen
            Administrator oder Treuhänder, um eine Einladung zu erhalten.
          </p>
          <Button asChild className="mt-5 w-full" data-testid="register-back-to-login">
            <Link to="/login">Zum Login</Link>
          </Button>
        </Card>
      ) : (
      <Card className="w-full max-w-md p-6 border border-slate-200 shadow-sm bg-white">
        <h1 className="text-2xl font-semibold text-slate-900 mb-2">Registrierung</h1>
        <p className="text-sm text-slate-500 mb-4">
          Erstellen Sie ein Konto, um Ihre Buchhaltung zu verwalten.
        </p>

        {error && (
          <div className="mb-3 rounded-md border border-rose-200 bg-rose-50 px-3 py-2 text-xs text-rose-800">
            {error}
          </div>
        )}

        <form className="space-y-3" onSubmit={handleSubmit} data-testid="register-form">
          <div className="space-y-1">
            <Label htmlFor="email">E-Mail</Label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmailState(e.target.value)}
              data-testid="register-email-input"
            />
          </div>
          <div className="space-y-1">
            <Label htmlFor="password">Passwort</Label>
            <Input
              id="password"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="register-password-input"
            />
          </div>
          <div className="space-y-1">
            <Label htmlFor="password2">Passwort wiederholen</Label>
            <Input
              id="password2"
              type="password"
              autoComplete="new-password"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              data-testid="register-password2-input"
            />
          </div>
          <div className="text-xs text-slate-500">
            <Link to="/login" className="hover:underline" data-testid="register-login-link">
              Bereits ein Konto? Anmelden
            </Link>
          </div>
          <div className="flex justify-end">
            <Button
              type="submit"
              size="sm"
              className="rounded-full bg-slate-900 text-slate-50 px-4"
              disabled={loading}
              data-testid="register-submit-button"
            >
              {loading ? "Registriere ..." : "Registrieren"}
            </Button>
          </div>
        </form>
      </Card>
      )}
      <PoweredByInvictaX className="mt-4" />
    </div>
  );
}
